{
  "name": "swagger-typescript-api-forked",
  "version": "13.0.22",
  "description": "Generate the API client for Fetch or Axios from an OpenAPI Specification",
  "homepage": "https://github.com/DemonStore/swagger-typescript-api",
  "bugs": "https://github.com/DemonStore/swagger-typescript-api/issues",
  "repository": "github:acacode/swagger-typescript-api",
  "license": "MIT",
  "author": "Sergey Volkov <js2me@outlook.com>",
  "contributors": [
    "Sora Morimoto <sora@morimoto.io>"
  ],
  "type": "module",
  "exports": {
    ".": {
      "import": {
        "default": "./dist/lib.js"
      },
      "require": {
        "default": "./dist/lib.cjs"
      }
    }
  },
  "main": "./dist/lib.cjs",
  "module": "./dist/lib.js",
  "bin": {
    "sta": "./dist/cli.js",
    "swagger-typescript-api": "./dist/cli.js"
  },
  "files": [
    "dist",
    "templates"
  ],
  "scripts": {
    "build": "tsup",
    "cli:help": "node index.js -h",
    "cli:json": "node index.js -r -d -p ./swagger-test-cli.json -n swagger-test-cli.ts",
    "cli:yaml": "node index.js -r -d -p ./swagger-test-cli.yaml -n swagger-test-cli.ts",
    "format": "biome format --write .",
    "format:check": "biome format .",
    "lint": "biome check",
    "prepack": "tsup",
    "test": "vitest run"
  },
  "dependencies": {
    "@types/swagger-schema-official": "^2.0.25",
    "citty": "^0.1.6",
    "consola": "^3.4.0",
    "cosmiconfig": "^9.0.0",
    "eta": "^2.2.0",
    "js-yaml": "^4.1.0",
    "lodash": "^4.17.21",
    "nanoid": "^5.0.9",
    "prettier": "~3.5.0",
    "swagger-schema-official": "2.0.0-bab6bed",
    "swagger2openapi": "^7.0.8",
    "typescript": "~5.8.2"
  },
  "devDependencies": {
    "@biomejs/biome": "1.9.4",
    "@changesets/changelog-github": "0.5.1",
    "@changesets/cli": "2.28.1",
    "@tsconfig/node18": "18.2.4",
    "@tsconfig/strictest": "2.0.5",
    "@types/js-yaml": "4.0.9",
    "@types/lodash": "4.17.16",
    "@types/node": "22.13.10",
    "@types/swagger2openapi": "7.0.4",
    "axios": "1.8.2",
    "openapi-types": "12.1.3",
    "tsup": "8.4.0",
    "vitest": "3.0.8"
  },
  "packageManager": "yarn@4.7.0",
  "engines": {
    "node": ">=18.0.0"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org"
  }
}
